module.exports = __webpack_public_path__ + "static/media/x.ec055d01.svg";